// ローディング表示
$('.l-loading').show();
// ローディング終了後に実行したい処理を関数化
function showKVandHeader() {
  $("body").addClass('is-loading');
  setTimeout(function () {
    $("body").removeClass('is-loading');
    $("#js-kv-Ttl").addClass('is-show');
    setTimeout(function () {
      $(".l-header").addClass('is-show');
      setTimeout(function () {
        $(".l-header").addClass('is-loaded');
      }, 500);
    }, 1500);
  }, 500);
}

// 少し待ってからフェードアウトし、完了後にKV・ヘッダー処理
setTimeout(function() {
  $('.l-loading').fadeOut(800, function() {
    showKVandHeader();
  });
}, 1900);
